import ApiConfig from "../Config";
import apiService from "../services/apiService";

const orderService = {
  getAllOrders: () => apiService.get(ApiConfig.getAllBookingRequest),

  getOrderById: (orderId, token) =>
    apiService.get(ApiConfig.getBookingRequestById, {
      headers: {
        "x-access-token": token,
        "order-id": orderId,
      },
    }),

  getPdfCordinates: (token) =>
    apiService.get(ApiConfig.getInvoiceById, {
      headers: {
        "x-access-token": token,
        "layout-id": "ID1731046499022_1272",
      },
    }),

  getInvoiceById: (token) =>
    apiService.get(ApiConfig.getInvoiceById, {
      headers: {
        "x-access-token": token,
        "layout-id": "ID1731046499022_1272",
      },
    }),
};
export default orderService;
